import { useState, useEffect, useMemo } from 'react';
import type { StepContentProps } from '~/ui-rocco/multi-step-form';
import { StepContent } from '../StepContent';
import { HdeOptionList } from '../HDEOptionList';
import type { StageConfiguration } from '@modules/build-hub/configs/stage-config';
import { getScopesByProjectType } from '@modules/build-hub/configs/stage-config';

const HDE_SCOPE_OPTIONS = [
    { value: 'New Build', label: 'New Build' },
    { value: 'Renovation', label: 'Renovation' },
    { value: 'Extension', label: 'Extension' },
    { value: 'Landscaping', label: 'Landscaping' },
    { value: 'Interior refresh', label: 'Interior refresh' },
    { value: 'Commercial fitout', label: 'Commercial fitout' },
    { value: 'Just researching', label: 'Just researching' },
];

interface ProjectScopeData {
    projectScope: string | null;
    projectType: 'Residential' | 'Commercial' | null;
    stageConfig?: StageConfiguration;
}

export function ProjectScopeStep({
    setIsValid,
    onDataChange,
    onNext,
    initialData,
}: StepContentProps) {
    const data = initialData as ProjectScopeData | undefined;
    const stageConfig = data?.stageConfig;
    const projectType = data?.projectType || 'Residential';

    const [projectScope, setProjectScope] = useState<string | null>(
        data?.projectScope || null,
    );

    const scopeOptions = useMemo(() => {
        if (stageConfig) {
            const scopes = getScopesByProjectType(stageConfig, projectType);
            if (scopes.length > 0) {
                return scopes.map((scope) => ({
                    value: scope.label,
                    label: scope.label,
                }));
            }
        }
        return HDE_SCOPE_OPTIONS;
    }, [stageConfig, projectType]);

    useEffect(() => {
        const isValid = projectScope !== null;
        setIsValid(isValid);
        onDataChange?.({ projectScope });
    }, [projectScope, setIsValid, onDataChange]);

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <StepContent>
                <HdeOptionList
                    label="What is the scope of your project?"
                    options={scopeOptions}
                    mode="single"
                    value={projectScope}
                    onChange={setProjectScope}
                    appearance="button"
                    onSelectAndAdvance={(value) => {
                        onDataChange?.({ projectScope: value });
                        onNext();
                    }}
                />
            </StepContent>
        </div>
    );
}
